import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative pt-[60px] md:pt-[72px] min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20warm%20gradient%20background%20with%20soft%20light%20rays%2C%20film%20texture%20overlay%2C%20coral%20and%20amber%20tones%2C%20elegant%20theater%20atmosphere%2C%20subtle%20geometric%20shapes%2C%20luxurious%20entertainment%20visual&width=1800&height=900&seq=hero-bg&orientation=landscape"
          alt="91麻豆免费视频网站 · 综合性影视在线观看平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4 md:mb-5">
              {heroData.tags.map((tag) => (
                <span key={tag} className="px-3 py-1 text-xs md:text-sm rounded-full bg-white/15 text-white/90 backdrop-blur-sm border border-white/20 whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white leading-tight mb-3 md:mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-white/80 font-label mb-5 md:mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed mb-6 md:mb-7 max-w-[620px] mx-auto lg:mx-0">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">{stat.value}</div>
                  <div className="text-xs text-white/55 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-medium text-sm md:text-base rounded-full transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="w-full sm:w-auto px-8 py-3 border border-white/25 hover:border-white/50 text-white font-label font-medium text-sm md:text-base rounded-full transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20composition%20with%20warm%20coral%20and%20gold%20light%20streaks%2C%20overlapping%20film%20frames%2C%20luxurious%20theater%20curtain%20motif%2C%20elegant%20entertainment%20visual%2C%20rich%20textures%20and%20soft%20glow&width=1040&height=780&seq=hero-right&orientation=landscape"
                alt="91麻豆免费视频网站 · 精彩影视在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}